angular.module('app').service('ConfiguracoesAppService', function ($http) {
  this.get = () => $http.get('/api/configuracoes-app').then(({ data }) => data);

  this.save = (configuracoes) => $http.post('/api/configuracoes-app', configuracoes).then(({ data }) => data);
});
